<template>
  <div class="page team">
    <div class="top">
      <div class="icon"></div>
      <div class="title"><span>Equipe</span></div>
    </div>
    <div class="content">
      <div class="cargoCat" v-for="(cc, index) in cargo_cat" :key="index">
        <div class="icon"></div>
        <div class="cat">{{ cc.category }}</div>
        <div class="cargos">
          <div class="cargo" v-for="(c, index) in cc.cargos" :key="index"
               @click="() => {getUsers(c.id); scrol($event)}">
            {{ c.cargo }}
          </div>
        </div>
      </div>
    </div>
    <div class="content forTeam" v-show="equipe.length > 0">
      <TransitionGroup name="custom-classes" enter-active-class="animate__animated animate__pulse"
                       leave-active-class="animate__animated animate__bounceOut">
        <div class="box" v-for="(e, index) in equipe" :key="index" @click="() => {showP = true; perfilName = e.user}">
          <div class="avatar"
               :style="{backgroundImage: `url('${avatarUrl(e.user, { headonly: 0 })}')`}"></div>
          <div class="user">
            <span :class="{'rh-plus': e.user === 'Zinii' || e.user === 'Grons'}">{{ e.user }}</span>
          </div>
        </div>
      </TransitionGroup>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>

import ItemPerfil from '@/components/modals/perfil.vue'
import { getEquipeCats, getEquipeUsers, avatarUrl } from '@/services/api.js'
import { ref } from 'vue'

const cargo_cat = ref([])
const equipe = ref([])
const showP = ref(false)
const perfilName = ref('')

async function getCat() {
  cargo_cat.value = await getEquipeCats()
}

async function getUsers(role) {
  // role aqui é o id do cargo (ex: 'locutor', 'dj') vindo do click
  equipe.value = await getEquipeUsers(role)
}

function scrol(e) {
  if (e?.preventDefault) e.preventDefault()
  document.querySelector('.forTeam')?.scrollIntoView({ behavior: 'smooth' })
  // .scrollIntoView({behavior: 'smooth'});
  // window.scrollTo({
  // 	top: 800,
  // 	left: 0,
  // 	behavior: 'smooth'
  // });
}

getCat()

</script>

<style scoped>
.page .top .icon {
  background-color: #21415C;
  background-position: -4px -96px;
}

.team .content .cargoCat {
  float: left;
  width: 100%;
  height: auto;
  margin-top: 8px;
}

.team .content .cargoCat .icon {
  float: left;
  width: 34px;
  height: 34px;
  background-image: url('../assets/icons.png');
  background-position: -4px -96px;
  background-color: var(--color1);
  border-radius: 20px;
}

.team .content .cargoCat .cat {
  float: left;
  width: auto;
  height: 34px;
  border-radius: 12px;
  background-color: var(--color1);
  color: #fff;
  font-weight: 800;
  padding: 0 10px;
  line-height: 34px;
  margin-left: 10px;
}

.team .content .cargoCat .cargos {
  float: left;
  width: 100%;
  height: auto;
}

/*noinspection ALL*/
.team .content .cargoCat .cargos .cargo {
  float: left;
  width: auto;
  height: 34px;
  background-color: var(--color2);
  color: #fff;
  font-weight: 300;
  line-height: 34px;
  border-radius: 12px;
  padding: 0 14px;
  margin: 8px 8px 0 0;
  cursor: pointer;
}

.team .content.forTeam {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  flex-flow: wrap;
  transition: all .3s ease;
}

.team .content > .box {
  width: calc(25% - 10px);
  height: 184px;
  background-color: var(--color1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  margin: 4px 0;
}

.team .content > .box .avatar {
  float: left;
  width: 60px;
  height: 130px;
  background-position: center;
  background-repeat: no-repeat;
  margin: 00px 0 10px 50%;
  transform: translateX(-50%);
}

.team .content > .box .user {
  float: left;
  width: calc(100% - 20px);
  height: 36px;
  line-height: 36px;
  text-align: center;
  user-select: none;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, .4);
  margin-left: 10px;
}

.team .content > .box .user span {
  font-weight: 600;
  font-size: 14px;
}
</style>
